import { FunctionComponent } from "react";
import { Body1, Modal, ModalType } from "@horizontal-org/shira-ui";
import styled from "styled-components";
import { useTranslation } from "react-i18next";


interface Props {
  // quiz: Quiz
  title: string;
  content: string | React.ReactNode;
  isModalOpen: boolean;
  setIsModalOpen: (handle: boolean) => void
  onDelete: () => void
  onCancel: () => void
  primaryButtonText?: string
}

export const DeleteModal: FunctionComponent<Props> = ({
  isModalOpen,
  setIsModalOpen,
  onDelete,
  onCancel,
  title = '',
  content = '',
  primaryButtonText
}) => {

  const { t } = useTranslation();

  return (
    <Modal
      id="delete-modal"
      isOpen={isModalOpen}
      title={title}
      primaryButtonText={primaryButtonText ?? t('buttons.delete')}
      secondaryButtonText={t('buttons.cancel')}
      type={ModalType.Danger}
      onPrimaryClick={() => {
        setIsModalOpen(false);
        onDelete()
      }}
      onSecondaryClick={onCancel}
    >
      <FormContent>
        <Body1>
          {content}
        </Body1>
      </FormContent>
    </Modal>
  )
}

const FormContent = styled.div`
  display: flex;
  flex-direction: column;
`;